import { createSlice } from '@reduxjs/toolkit';
import { fetchSignature } from './signatureThunks';

const signatureSlice = createSlice({
  name: 'signature',
  initialState: {
    data: null,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSignature.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSignature.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchSignature.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default signatureSlice.reducer;